declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
    zaraz?: {
      track: (event: string, payload?: Record<string, unknown>) => void;
    };
  }
}

export function getUtmParams(): Record<string, string> {
  if (typeof window === 'undefined') {
    return {};
  }
  const params = new URLSearchParams(window.location.search);
  const utm: Record<string, string> = {};
  for (const key of [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
  ]) {
    const value = params.get(key);
    if (value) {
      utm[key] = value;
    }
  }
  return utm;
}

/** Append current-page UTMs to an app signup/login URL. */
export function appendUtmParamsToUrl(url: string): string {
  const utms = getUtmParams();
  if (Object.keys(utms).length === 0) {
    return url;
  }

  const next = new URL(url);
  for (const [key, value] of Object.entries(utms)) {
    next.searchParams.set(key, value);
  }
  return next.toString();
}

export function buildSignupUrl(baseSignupUrl: string): string {
  return appendUtmParamsToUrl(baseSignupUrl);
}

/** Zaraz/GA event when a marketing CTA sends someone to app signup. */
export function trackSignupClick(source: string): void {
  trackMarketingEvent('signup_click', { cta_source: source });
}

/** Prefer Cloudflare Zaraz (edge-loaded GA/GTM). Fall back to dataLayer if present. */
export function trackMarketingEvent(
  event: string,
  params: Record<string, unknown> = {},
): void {
  const payload = {
    page_path: window.location.pathname,
    page_location: window.location.href,
    ...getUtmParams(),
    ...params,
  };

  if (window.zaraz?.track) {
    window.zaraz.track(event, payload);
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...payload });
}
